export const getPageContentLabel = (cmsData, componentKey, key) => {
    const labels = cmsData?.pageContent?.[componentKey]?.Labels;
    if (!labels || !key) {
        return "";
    }

    return labels.find((x) => x.Key === key)?.Phrase || "";
};
